export function objectToArray(object) {
  const arr = [];
  for (const key in object) {
    arr.push(object[key]);
  }

  return arr;
}

export function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

export function tokenizeUrl(url) {
  return url.split("/");
}

export function isFunction(func) {
  return typeof func === "function";
}

export function localeCurrencyFormatter({ currency, value, locale }) {
  return value.toLocaleString(locale, {
    currency,
    currencyDisplay: "code",
    style: "currency"
  });
}
